import { EntityType, ENTITY_TYPES } from '@/config/entityTypes'
import { CATEGORICAL, GRACKLE_COLORS } from '@/lib/theme'
import { cn } from '@/lib/utils'

interface CategoryBadgeProps {
  type: EntityType
  className?: string
}

export function CategoryBadge({ type, className }: CategoryBadgeProps) {
  const config = ENTITY_TYPES[type]
  const c = CATEGORICAL[config.category]
  const Icon = config.icon

  // GRK-BRAND-1 badge: family `tint` fill + Prussian text/icon (>= 8:1 on every
  // tint) + `solid` border for the hue edge. Icon uses Prussian (not solid) so
  // it stays legible even where tint === solid (Pollen / Powder).
  return (
    <div
      className={cn(
        'inline-flex items-center gap-1.5 px-3 py-1 rounded-md text-sm font-medium border',
        className
      )}
      style={{
        backgroundColor: c.tint,
        color: GRACKLE_COLORS.prussianBlue,
        borderColor: c.solid,
      }}
      role="status"
      aria-label={`${config.label} page`}
    >
      <Icon className="h-3.5 w-3.5" aria-hidden="true" />
      <span>{config.label}</span>
    </div>
  )
}
